import axios from "axios";

import { enrollmentStatus } from "../../../modules/constants";
import { HttpCodes } from "../../../modules/constants";

const SET_SITES = "SET_SITES";

const getSites = (state) => state.sites;

const initialState = {
  sites: [],
};

export const addUserAccessManagementReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SET_SITES:
      const { sites } = action;

      return {
        ...state,
        sites,
      };
    default:
      return state;
  }
};

export const inviteAdminUser =
  (email, roleName, study, sites) => (dispatch, getState) => {
    return axios
      .post(`/api/account/management/invite`, {
        Email: email,
        Rolename: roleName,
        study: study,
        sites: sites,
      })
      .then(() => {
        return Promise.resolve("User invited successfully!");
      })
      .catch((err) => {
        let errorMessage =
          "There was an error while trying to invite the user!";
        if (err?.response?.status === HttpCodes.CONFLICT) {
          errorMessage =
            "The email address you have entered is already registered.";
        } else if (err?.response?.status === HttpCodes.PRE_CONDITION_FAILED) {
          errorMessage = "This email is not whitelisted. Please contact IT.";
        }
        return Promise.reject(errorMessage);
      });
  };

export const updateAdminUser =
  (id, username, roleName, study, sites) => (dispatch, getState) => {
    return axios
      .put(`/api/account/management/update`, {
        adminUserID: id,
        username: username,
        rolename: roleName,
        study: study,
        sites: sites,
      })
      .then(() => {
        return Promise.resolve("An email was sent. User updated successfully!");
      })
      .catch((err) => {
        return Promise.reject(
          err?.response?.data ??
            "There was an error while trying to update the user!"
        );
      });
  };

export const updateUserData = (userid, study) => (dispatch, getState) => {
  return axios
    .post(`/api/study/enroll`, {
      study: study,
      ParticipantID: userid,
      Status: enrollmentStatus.SADPeriod,
    })
    .then(() => {
      return Promise.resolve("An email was sent. User updated successfully!");
    })
    .catch(() => {
      return Promise.reject(
        "There was an error while trying to update the user!"
      );
    });
};

export const fetchSites = (studyId) => (dispatch, getState) => {
  const params = {
    studyId: studyId,
  };

  return axios
    .get(`/api/study/sites`, { params })
    .then(({ data }) => {
      const sites = data?.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      dispatch({ type: SET_SITES, sites: sites });
    })
    .catch(() => {});
};

export const mapStateToProps = (state) => {
  return {
    sites: getSites(state),
  };
};

export const mapDispatchToProps = {
  inviteAdminUser,
  updateAdminUser,
  updateUserData,
  fetchSites,
};
